module.exports = __webpack_public_path__ + "media/react/fonts/fa-solid-900-dbe8505cf4eb137c63b6c375e02c225e.woff2";